import Constants from "./Constants";

const { ActionStates, WarningTypes, SortBoxDivertReason } = Constants;

export const groupBy = (list, key) => {
  var groups = list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
  return groups;
};

export const getMessageIcon = (type) => {
  let messageIconName;
  switch (type) {
    default:
      messageIconName = void 0;
      break;

    case ActionStates.LOAD_BOX:
      messageIconName = "barcode";
      break;
    case ActionStates.BOX_LOADED:
      messageIconName = "cube";
      break;
  }
  return messageIconName;
};

export const getOperatorMessage = (type) => {
  let message;
  switch (type) {
    case ActionStates.LOAD_BOX:
      return (message = "SCANNA LÅDA");
    case ActionStates.BOX_LOADED:
      return (message = "KONTROLLERA LÅDA");
    case ActionStates.PUTAWAY_STOCK:
      return (message = "HANTERA LAGER");
    default:
      message = void 0;
      break;
  }
  return message;
};
export const mapExistingSortboxItemsFromAllSortboxItems = (allSortBoxItems, boxItems) => {
  return boxItems === allSortBoxItems
    ? boxItems
    : allSortBoxItems.map(
      (k) =>
        boxItems.filter(
          (p) => p.skuID === k.skuID && p.shelfNumber === k.shelfNumber && p.boxID === k.boxID && p.isRxItem === k.isRxItem
        )[0] ?? k
    );
};

export const sortAllSortBoxItemsByExistingSortboxItems = (allSortBoxItems, boxItems) => {
  return allSortBoxItems.sort((k) =>
    boxItems.some((p) => p.skuID === k.skuID && p.shelfNumber === k.shelfNumber && p.isRxItem === k.isRxItem) ? -1 : 1
  );
};

export const getWarningMessage = (reason) => {
  switch (reason) {
    default:
      return "Okänt fel:" + reason;
    case SortBoxDivertReason.AFRAME_OTHER:
      return "Plockfel.";
    case SortBoxDivertReason.FILLING_POINT:
      return "Fel vid påfyllnadspunkten (fillingpoint).";
    case SortBoxDivertReason.HEIGHT:
      return "Max höjd överskriden.";
    case SortBoxDivertReason.CHECK_REQUESTED:
      return "Manuell kontroll.";
    case SortBoxDivertReason.WEIGHT:
      return "Viktfel.";
    case SortBoxDivertReason.UNKNOWN_LU:
      return "Okänd låda, saknar scanning.";
    case SortBoxDivertReason.AFRAME_ORDER_LINE_OTHER:
      return "Okänt fel.";
    case SortBoxDivertReason.PRODUCT_STUCK:
      return "Produkt sitter fast i kanal.";
    case SortBoxDivertReason.CHANNEL_LOCKED:
      return "Kanalen är låst.";
    case SortBoxDivertReason.CHANNEL_EMPTY:
      return "Kanalen är tom.";
    case SortBoxDivertReason.UNFILLED_QUANTITY:
      return "Felaktigt antal plockade från kanal.";
    case SortBoxDivertReason.READ_ERROR:
      return "Läsfel, lådans streckkod kunde ej scannas.";
    case SortBoxDivertReason.PBL_FULL_ORDER_CARTON:
      return "Full låda vid PBL.";
    case SortBoxDivertReason.DIRTY_CARTON_PBL:
      return "Felaktig låda vid PBL.";
    case SortBoxDivertReason.PBL_HARDWARE_ERROR:
      return "Hårdvarufel på PBL-kanal";
    case SortBoxDivertReason.NO_OPEN_STATION:
      return "Ingen tillgänlig station för ordern.";
    case SortBoxDivertReason.STATION_STILL_OPEN:
      return "Packstation för ordern är fortfarande öppen.";
    case SortBoxDivertReason.BOX_LOST_OR_REMOVED:
      return "Lådan borttappad eller flyttad.";
    case SortBoxDivertReason.SHIPPING_LABEL_ERROR:
      return "Etikettfel.";
    case SortBoxDivertReason.GENERAL_PBL_ERROR:
      return "Generellt PBL-fel.";
    case SortBoxDivertReason.AFRAME_UNEXPECTED_PRODUCT:
      return "Aframe, oväntad produkt på bandet.";
    case SortBoxDivertReason.MAXIMUM_CIRCULATION_REACHED:
      return "Lådan har uppnått det maximala antalet varv för en loop.";
    case SortBoxDivertReason.MAGIC_ZONE:
      return "Magic Zone.";
    case SortBoxDivertReason.PRINT_FILE_MISSING_OR_SHIPPING_LABEL_MISSING_OR_UNREADABLE:
      return "Etikettfel, etiketten saknas alt. läsfel.";
    case SortBoxDivertReason.APOTEA_RX_BOX_INSPECTION_REQUIRED:
      return "Misstanke om felpackad rx-påse, kontrollera att påsarna tillhör lådan.";
    case SortBoxDivertReason.APOTEA_RX_BOX_WITH_INCORRECT_STATE_AT_CHECKSTATION:
      return "Ofullständig Rx-order, manuell hantering krävs";
    case SortBoxDivertReason.NO_ITEM_FOUND_DISCARD_BOX:
      return "Kassera lådan";
  }
};

export const isNonExistentChannel = (channel) => {
  return channel == 50039 || channel == 20039 || channel == 40039;
};

